import React, { useEffect } from 'react';
import { List, Datagrid, TextField, FunctionField } from 'react-admin';

function NoticiasList(props: any) {
  useEffect(() => {
    document.title = 'Noticias - Gasco';
  }, []);

  const renderBlocksPreview = (blocks: any) => {
    if (!blocks) return null;
    if (typeof blocks === 'string') return blocks.length > 100 ? blocks.substring(0, 100) + '…' : blocks;
    if (Array.isArray(blocks)) {
      try {
        const text = blocks
          .map((b: any) => {
            if (typeof b === 'string') return b;
            if (Array.isArray(b.children)) return b.children.map((c: any) => c.text || '').join('');
            if (b.text) return b.text;
            return '';
          })
          .join(' ')
          .trim();
        return text.length > 100 ? text.substring(0, 100) + '…' : text;
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="anoImage" label="Año" />
        <TextField source="slug" label="Slug" />
        <FunctionField
          label="Imagen"
          render={(record: any) =>
            record.image ? (
              <img
                src={record.image.url}
                alt={record.slug || 'imagen'}
                style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
              />
            ) : null
          }
        />
        <FunctionField
          label="Vista previa"
          render={(record: any) => renderBlocksPreview(record.descripcion || record.descripcionImage || record.descripcionDetalle)}
        />
        <FunctionField
          label="Imagen detalle"
          render={(record: any) =>
            record.imageDetalle ? (
              <img
                src={record.imageDetalle.url}
                alt="detalle"
                style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
              />
            ) : null
          }
        />
      </Datagrid>
    </List>
  );
}

export default NoticiasList;
